module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "partners"
  }, [_c('div', {
    staticClass: "partners-heading block-heading-font-style"
  }, [_vm._v("THE ENTIRE FAMILY OF ATTACH")]), _vm._v(" "), _c('div', {
    staticClass: "partners-subheading block-subheading-font-style"
  }, [_vm._v("MikMak has an Attach experience for every stage in the shopper's journey.")]), _vm._v(" "), _c('div', {
    staticClass: "all-attach-items"
  }, _vm._l((_vm.attachFamilyList), function(attachProduct) {
    return _c('span', {
      staticClass: "attach-item"
    }, [_c('img', {
      attrs: {
        "src": _vm.getImgUrl(attachProduct.slug)
      }
    }), _vm._v(" "), _c('span', {
      class: ("attach-item-title attach-product-badge badge-for-" + (attachProduct.slug))
    }, [_vm._v(_vm._s(attachProduct.name))])])
  }), 0), _vm._v(" "), _c('a', {
    staticClass: "attach-item-request-demo-button",
    attrs: {
      "href": "#contact-footer"
    },
    on: {
      "click": function($event) {
        return _vm.clickedRequestDemoButton()
      }
    }
  }, [_vm._v("Request a demo of all Attach")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39503a22"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/AttachFamily.vue
// module id = 471
// module chunks = 0